<template>
  <div>
    <MasterLayout>
      <section class="mt-3 full__row_section">
        <div class="row">
          <div class="col-md-12">
            <div
              class="dashboard__card large_card card_padding indus_back_img_lg"
            >
              <div
                class="row make-row-hundred-percent align-items-center justify-content-center"
              >
                <div class="col-md-2">
                  <div
                    class="icon_wrapper yellow centralize icon_div_big"
                    style=""
                  >
                    <img src="@/assets/img/oil-truck.svg" width="" />
                  </div>
                </div>
                <div class="col-md-5 remove-padding-left">
                  <div class="">
                    <h4 class="text-white mobile_text">
                      {{ $t("text.iWalletTransactions.title") }} ({{
                        transactionCount
                      }})
                    </h4>
                  </div>
                  <div class="mt-5">
                    <h5 class="text-white mt-1 mobile_text_para">
                      {{ $t("text.iWalletTransactions.getReports") }}
                    </h5>
                  </div>
                </div>
                <div class="col-md-4 remove-padding-left">
                  <div class="">
                    <vue-ctk-date-time-picker
                      v-model="dateRange"
                      :max-date="maxDate"
                      :range="true"
                      :autoClose="true"
                      :locale="this.$root.$i18n.locale"
                      :custom-shortcuts="customShortcuts"
                      color="#370F70"
                      format="DDMMYYYY"
                      formatted="DD/MM/YYYY"
                      :label="$t('text.calendar.dateRange')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="mt-3 full__row_section">
        <div
          class="row top_section_row mb-3 table_margin_top_m"
          style="border-radius: 20px"
        >
          <div class="col-md-8">
            <span class="date_info_span"
              >{{ $t("text.iWalletTransactions.walletTransBtw") }}
              <!-- {{ $d(new Date(startDate), 'short', this.$root.$i18n.locale) }} -->
              {{ $t("text.and.text") }}
              {{ startDate }} and {{ endDate }}
              <!-- {{ $d(new Date(endDate), 'short', this.$root.$i18n.locale) }} -->
            </span>
            <span></span>
          </div>
          <div class="col-md-4 text-right"></div>
        </div>
        <ejs-grid
          v-show="!showLoader"
          ref="dataGrid"
          :dataBound="dataBound"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :rowDataBound="rowDataBound"
          :locale="usedLang"
        >
          <e-columns>
            <e-column width="40" field="index" headerText="#"></e-column>
            <e-column field="date" width="200" headerText="Date"></e-column>
            <e-column
              field="amount"
              width="150"
              :headerText="
                $t('text.iWalletTransactions.amount', {
                  currency: `(${
                    industryBranch ? industryBranch.currency : ''
                  })`,
                })
              "
            ></e-column>
            <e-column
              field="source"
              width="280"
              :headerText="$t('text.iWalletTransactions.source')"
            ></e-column>
            <e-column
              field="status"
              width="150"
              :headerText="$t('text.iWalletTransactions.status')"
            ></e-column>
            <e-column
              field="walletBalance"
              width="200"
              :headerText="
                $t('text.iWalletTransactions.walletBalance', {
                  currency: `(${
                    industryBranch ? industryBranch.currency : ''
                  })`,
                })
              "
            ></e-column>
          </e-columns>
        </ejs-grid>
        <TableLoader :showLoader="showLoader" />
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Wallet Transactions:: Epump Industrial Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      showLoader: true,
      transactionCount: 0,
      startDate: this.$moment().subtract(14, "days").format("MMMM D, YYYY"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      powerGridHours: 0,
      genHours: 0,
      totalVolumeSold: 0,
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(700, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: {
        start: this.$moment().subtract(7, "days").format("D-M-YYYY"),
        end: this.$moment().format("D-M-YYYY"),
      },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      backImg,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      walletTransactionStartDate: this.$moment()
        .subtract(7, "days")
        .format("D-M-YYYY"),
      walletTransactionEndDate: this.$moment().format("D-M-YYYY"),
      industryBranch: null,
      industryBranchId: null,
    };
  },
  created() {
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = `Industry Dashboard - ${industryBranch.name}`;
    });
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
      }
    },
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
        this.getWalletTransactions();
      }
    },
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
    this.getWalletTransactions();
  },

  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    getWalletTransactions() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/RemisWalletTransactions/${this.industryBranch.id}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.showLoader = false;
          let index = 0;
          res.data.sort((a, b) => {
            if (a.date !== b.date) {
              return a.date > b.date ? -1 : a.date < b.date ? 1 : 0;
            }
          });
          res.data.forEach((el, index) => {
            el.index = index + 1;
            el.amount = this.decimalThousand(el.amount);
            el.walletBalance = this.decimalThousand(el.walletBalance);
            if (el.status.toLowerCase() === "add") {
              el.status = "Credit";
            }
            el.date = this.$moment(el.date).format("MM/DD/YYYY hh:mm A");
          });

          this.transactionCount = res.data.length;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    dataBound: function () {
      this.$refs.dataGrid.autoFitColumns();
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
    rowDataBound: function (args) {
      if (args.data["status"] === "Debit") {
        args.row.cells[4].style.color = "red";
      }
      if (args.data["status"] === "Credit") {
        args.row.cells[4].style.color = "green";
      }
    },
    decimalThousand(number) {
      if (!isFinite(number)) {
        return "0.00";
      }
      return number
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
